<template lang="pug">
    filter-mobile
        form.c-form.inverse

            // Sort by Program Title
            v-select(
                name="name"
                append-icon="expand_more"
                outline
                v-model="sort.name"
                @change="e => sortHandler('title', e)"
                :items="$t('selection.sort')"
                :label="$t('programs.mobile.sort.name')"
            )
</template>

<script>
    import VueTypes from 'vue-types';
    import FilterMobile from '~components/FilterMobile';

    export default {
        components: {
            FilterMobile
        },
        props: {
            sortHandler: VueTypes.func.def(() => {})
        },
        data() {
            return {
                sort: {
                    name: null
                }
            };
        }
    };
</script>
